// const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

// Centralized API URL - Change this in one place to update the entire application
export const API_URL = "https://staffingtestapi.worldgurujiedu.org";
// https://zenxstaffingapi.worldgurujiedu.org
export default API_URL;
